import { Suspense, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import '../lib/i18n'  // side-effect: initialises i18next

interface I18nProviderProps {
  children: ReactNode
}

/**
 * Wraps the app in a React Suspense boundary for i18next.
 * When useSuspense: true, react-i18next suspends while loading translation
 * files over HTTP. This boundary shows a minimal fallback instead of
 * unmounted content or missing strings.
 */
function I18nSuspenseFallback() {
  const { t } = useTranslation('common')
  return <div className="min-h-screen bg-background" aria-label={t('aria.loading')} />
}

export function I18nProvider({ children }: I18nProviderProps) {
  return (
    <Suspense fallback={<I18nSuspenseFallback />}>
      {children}
    </Suspense>
  )
}
